import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { CompanyBondModel } from '@data-layer/models/companies';
import { HttpErrorResponse } from '@angular/common/http';
import { enumRespErrors } from '../enums/common';
import { ContinuousBondDetailsModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class CompanyBondsRepository {
  constructor(private apiService: ApiService) {}

  public get(companyId: number, isUsed: boolean = false, isShowLoader: boolean = true): Observable<CompanyBondModel[]> {
    return this.apiService.get<CompanyBondModel[]>(`${environment.url.companies}${companyId}/bonds`, null, {
      isUsed,
      isShowLoader,
    });
  }

  public delete(companyId: number, isShowLoader: boolean = false): Observable<never> {
    return this.apiService.delete(`${environment.url.companies}${companyId}/bonds`, null, { isShowLoader });
  }

  public updated(companyId: number, isShowLoader: boolean = false): Observable<never> {
    return this.apiService.post(`${environment.url.companies}${companyId}/bonds/updated`, null, null, { isShowLoader });
  }

  public updateCompanyBonds(companyId: number): Observable<never> {
    return this.delete(companyId).pipe(switchMap(() => this.updated(companyId)));
  }

  public connectBondRequest(companyId: number, bondRequestId: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.put(`${environment.url.companies}${companyId}/bond-request-id`, bondRequestId, null, { isShowLoader });
  }

  public disconnectBondRequest(companyId: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.delete(`${environment.url.companies}${companyId}/bond-request-id`, null, { isShowLoader });
  }

  public getLastBondRequest(companyId: number, isShowLoader: boolean = true): Observable<ContinuousBondDetailsModel> {
    return this.apiService.get(`${environment.url.companies}${companyId}/last-continuous-bond-request-detail`);
  }

  public getErrorMessage(error: HttpErrorResponse): string {
    if (error?.error?.tag) {
      switch (error.error.tag) {
        case enumRespErrors.BondAlreadySet:
          return 'KNOWN_ERRORS.ALREADY_SET';
        default:
          break;
      }
    }
  }
}
